/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ui-action-expander .ui-action-expander-container{display:block;text-align:right;position:absolute;min-width:50vw;height:0;top:0;right:40px}ui-action-expander .ui-action-expander-container>button{margin-right:10px}"];
export { styles as styles };
